/**
 * SVG path geometry for the Helldivers 1 galactic war map.
 * Extracted from Map.jsx so both the React component and OG image route can share the same data.
 */

export const viewBox = '0 0 806.93 868.81';

/**
 * Bug faction paths (id prefix "0-"), sectors 1-11.
 */
export const bugPaths = [
    {
        id: '0-1',
        sector: 1,
        d: 'M433.74,403.35l30.16,10.96c1.04-2.84,1.87-5.74,2.49-8.66.79-3.7,1.25-7.53,1.38-11.4.03-.72.04-1.41.04-2.12,0-3.17-.23-6.34-.68-9.42l-.35-2.4,36.48-6.45c-.93-5.14-2.27-10.21-3.97-15.11-1.96-5.68-4.47-11.23-7.46-16.51-2.95-5.26-6.41-10.29-10.29-14.95-3.86-4.66-8.16-9.01-12.8-12.91-4.59-3.89-9.6-7.41-14.88-10.46-5.27-3.03-10.83-5.59-16.51-7.61-4.91-1.76-10-3.13-15.15-4.1l-11.99,68.14c1.17.25,2.32.58,3.45.97,1.92.64,3.82,1.5,5.63,2.53,1.76,1,3.46,2.19,5.04,3.54,1.59,1.36,3.03,2.85,4.3,4.45,1.3,1.62,2.43,3.35,3.36,5.14.94,1.74,1.73,3.65,2.33,5.63.59,1.91,1,3.91,1.22,5.93.13,1.17.2,2.38.2,3.6,0,.82-.03,1.63-.1,2.42-.12,1.87-.44,3.84-.95,5.81-.27,1.02-.58,2.02-.94,3Z',
    },
    {
        id: '0-2',
        sector: 2,
        d: 'M468.6,416.02l30.15,10.96c1.77-4.87,3.17-9.86,4.16-14.87l.47-2.4,36.51,6.42c1.26-7.2,1.95-14.54,2.05-21.87,0-.71.02-1.43.02-2.13,0-7.48-.6-14.98-1.79-22.29-1.3-8.09-3.33-16.09-6.04-23.78-2.7-7.69-6.13-15.22-10.2-22.38-3.62-6.38-7.79-12.53-12.42-18.3l-24.58,20.64c3.44,4.35,6.54,8.96,9.23,13.76,3.13,5.54,5.76,11.37,7.82,17.33,2.07,5.94,3.62,12.13,4.6,18.39l.38,2.42-36.6,6.47c.28,2.55.43,5.14.43,7.73,0,.77-.01,1.54-.04,2.3-.13,4.14-.63,8.28-1.48,12.26-.67,3.14-1.57,6.27-2.68,9.33Z',
    },
    {
        id: '0-3',
        sector: 3,
        d: 'M441.39,292.46c5.14,1.97,10.16,4.36,14.97,7.12,5.54,3.2,10.8,6.89,15.61,10.97,4.22,3.55,8.18,7.46,11.79,11.62l52.97-44.49c-6.22-7.24-13.05-14.01-20.33-20.16-7.96-6.69-16.53-12.7-25.48-17.85-8.25-4.76-16.94-8.87-25.89-12.23l-23.64,65.02Z',
    },
    {
        id: '0-4',
        sector: 4,
        d: 'M573.17,454.04l30.16,10.97c3.97-10.9,7.05-22.18,9.18-33.58,2.27-12.14,3.48-24.65,3.6-37.17.02-.73.02-1.43.02-2.13,0-11.81-.97-23.65-2.9-35.18-2.05-12.31-5.21-24.51-9.39-36.27-4.19-11.77-9.46-23.24-15.67-34.1-5.78-10.1-12.45-19.81-19.84-28.89l-52.98,44.48c4.82,6.01,9.17,12.41,12.94,19.05,4.21,7.41,7.76,15.21,10.56,23.18,2.81,7.97,4.91,16.26,6.26,24.64,1.23,7.57,1.85,15.33,1.85,23.09,0,.73,0,1.47-.02,2.2-.11,7.6-.82,15.21-2.13,22.67l36.54,6.43-.47,2.49c-1.8,9.54-4.4,18.98-7.72,28.12Z',
    },
    {
        id: '0-5',
        sector: 5,
        d: 'M568.97,250.62l1.61,1.93c8.22,9.86,15.6,20.47,21.94,31.55,6.35,11.11,11.75,22.85,16.04,34.9,4.28,12.04,7.52,24.53,9.61,37.13,1.95,11.69,2.94,23.68,2.96,35.65h32.07c-.02-13.88-1.18-27.76-3.46-41.28-2.41-14.42-6.13-28.72-11.06-42.52-4.91-13.77-11.11-27.21-18.4-39.95-7.29-12.73-15.75-24.88-25.15-36.12-9.38-11.24-19.85-21.73-31.09-31.2-11.25-9.46-23.38-17.97-36.05-25.29-12.74-7.35-26.18-13.59-39.96-18.55-12.98-4.69-26.47-8.31-40.12-10.78l-11.99,68.12c9.68,1.76,19.24,4.34,28.47,7.66,10.05,3.61,19.82,8.14,29.03,13.47,9.2,5.3,18.01,11.48,26.2,18.36,7.51,6.33,14.54,13.31,20.94,20.77l28.41-23.85Z',
    },
    {
        id: '0-6',
        sector: 6,
        d: 'M608.03,466.72l30.15,10.96c4.71-12.93,8.36-26.31,10.84-39.82l.45-2.44,73.05,12.86c3.1-17.77,4.72-35.94,4.82-54.05.02-.73.02-1.42.02-2.1,0-18.28-1.54-36.63-4.57-54.53-3.01-17.86-7.57-35.55-13.56-52.64l-34.84,12.7-.85-2.37c-5.37-15-12.07-29.67-19.91-43.63l-27.78,16.05c6.91,12.35,12.81,25.32,17.55,38.58,5.03,14.08,8.82,28.67,11.28,43.38,2.34,13.9,3.52,28.18,3.52,42.45,0,.73,0,1.46-.01,2.18l-.04,2.46h-37.08c-.25,12-1.47,23.95-3.65,35.58-2.18,11.67-5.34,23.22-9.4,34.37Z',
    },
    {
        id: '0-7',
        sector: 7,
        d: 'M655.48,244.82l1.25,2.18c8.1,14.13,15.05,29.01,20.66,44.25l30.15-10.99c-6.25-17-13.99-33.58-23.04-49.32-9.41-16.41-20.37-32.12-32.58-46.71-12.17-14.55-25.7-28.12-40.23-40.33-13.9-11.68-28.85-22.26-44.48-31.45l-34.56,59.91c12.15,7.18,23.78,15.42,34.61,24.53,11.47,9.65,22.14,20.36,31.71,31.82,9.05,10.82,17.25,22.48,24.39,34.67l32.12-18.56Z',
    },
    {
        id: '0-8',
        sector: 8,
        d: 'M565.39,105.6l2.17,1.25c16.67,9.63,32.6,20.8,47.36,33.21,14.75,12.4,28.5,26.18,40.85,40.95,11.86,14.17,22.56,29.38,31.82,45.26l27.78-16.05c-10.23-17.53-22.01-34.28-35.04-49.84-13.58-16.22-28.65-31.33-44.8-44.9-16.18-13.61-33.66-25.86-51.94-36.42-17.65-10.19-36.2-18.89-55.19-25.9l-25.34,69.69-2.35-.85c-15.07-5.44-30.65-9.62-46.37-12.44l-5.56,31.6c13.94,2.51,27.7,6.21,40.95,11,13.27,4.78,26.24,10.72,38.59,17.69l37.07-64.25Z',
    },
    {
        id: '0-9',
        sector: 9,
        d: 'M712.59,504.73l65.01,23.64c7.65-21.01,13.55-42.79,17.53-64.79,4.12-22.75,6.26-46.09,6.38-69.38,0-.7,0-1.39,0-2.08,0-22.64-1.92-45.33-5.69-67.43-3.76-22.12-9.44-44.02-16.9-65.13l-34.85,12.7-.85-2.36c-6.85-19.08-15.38-37.69-25.37-55.34l-27.78,16.05c9.07,16.07,16.81,32.98,23.02,50.29,6.5,18.09,11.42,36.89,14.62,55.86,3.08,18.18,4.64,36.81,4.64,55.37,0,.72,0,1.46-.02,2.18-.11,19.18-1.91,38.48-5.34,57.31-3.28,18-8.12,35.86-14.41,53.12Z',
    },
    {
        id: '0-10',
        sector: 10,
        d: 'M468.06,31.6c20.26,3.61,40.33,8.99,59.69,16,20.08,7.25,39.7,16.37,58.33,27.13,18.54,10.71,36.25,23.13,52.66,36.92,16.37,13.76,31.65,29.08,45.42,45.52,13.75,16.42,26.13,34.16,36.79,52.72,10.26,17.83,19.04,36.65,26.13,55.96l30.16-10.99c-7.73-21.07-17.31-41.59-28.5-61.04-11.58-20.13-25.04-39.41-40.01-57.29-14.95-17.86-31.57-34.5-49.38-49.46-17.83-15-37.09-28.5-57.23-40.13-20.2-11.66-41.52-21.59-63.38-29.49-21.09-7.64-42.99-13.51-65.11-17.45l-5.56,31.6Z',
    },
    {
        id: '0-11',
        sector: 11,
        d: 'M804.89,263.66l-110.94-175.61s60.31,84.75,112.98,51.47c0,0-58.88,34.16-2.04,124.14Z',
    },
];

/**
 * Cyborg faction paths (id prefix "1-"), sectors 1-11.
 */
export const cyborgPaths = [
    {
        id: '1-1',
        sector: 1,
        d: 'M337.72,314.29l23.81,28.35-1.78,1.62c-2.83,2.57-5.42,5.38-7.7,8.34-2.3,2.97-4.36,6.16-6.11,9.48-1.74,3.32-3.2,6.79-4.32,10.32-1.13,3.51-1.96,7.16-2.46,10.85-.4,2.89-.61,5.87-.61,8.88,0,.72,0,1.43.04,2.14.11,3.65.54,7.32,1.28,10.94.56,2.74,1.32,5.49,2.25,8.18l30.16-10.99c-.28-.84-.52-1.7-.73-2.57-.43-1.7-.71-3.5-.83-5.3-.06-.76-.1-1.58-.1-2.39,0-1.05.05-2.07.14-3.03.15-1.78.48-3.61.98-5.42.47-1.79,1.11-3.57,1.91-5.26.76-1.67,1.72-3.33,2.82-4.92,1.12-1.61,2.37-3.1,3.71-4.42,1.39-1.39,2.91-2.65,4.51-3.75,1.62-1.13,3.36-2.11,5.16-2.91,1.1-.5,2.24-.94,3.41-1.31l-12.07-68.31c-5.06,1.11-10.03,2.61-14.83,4.48-5.55,2.15-10.97,4.82-16.12,7.96-4.39,2.68-8.6,5.72-12.54,9.04Z',
    },
    {
        id: '1-2',
        sector: 2,
        d: 'M266.48,368.01l68.12,11.99c.54-3.1,1.3-6.16,2.26-9.13,1.21-3.8,2.78-7.54,4.66-11.12,1.89-3.59,4.1-7.03,6.58-10.22,1.98-2.56,4.18-5.02,6.54-7.33l-23.9-28.46,1.82-1.61c4.68-4.15,9.76-7.9,15.1-11.16h0c5.4-3.29,11.09-6.1,16.91-8.35,5.09-1.99,10.39-3.58,15.77-4.75l-5.58-31.62c-7.15,1.49-14.24,3.56-21.09,6.18-7.59,2.9-14.98,6.5-21.96,10.71-6.93,4.17-13.56,8.99-19.7,14.34-6.09,5.31-11.75,11.2-16.84,17.49-5.09,6.29-9.64,13.05-13.52,20.08-3.91,7.08-7.21,14.5-9.78,22.05-2.33,6.78-4.14,13.8-5.39,20.92Z',
    },
    {
        id: '1-3',
        sector: 3,
        d: 'M262.39,232.35c-8.68,7.66-16.77,16.05-24.08,24.97-7.82,9.55-14.87,19.87-20.93,30.67-6.06,10.78-11.19,22.14-15.25,33.76-4.07,11.63-7.14,23.69-9.11,35.84-1.85,11.31-2.79,22.93-2.79,34.54,0,.75,0,1.49.02,2.22.12,12.31,1.3,24.65,3.53,36.71,2.09,11.27,5.1,22.4,8.95,33.11l134.7-49.08c-1.02-2.92-1.84-5.9-2.45-8.89-.79-3.9-1.26-7.86-1.38-11.77-.03-.75-.04-1.53-.04-2.32,0-2.41.12-4.81.36-7.17l-73.15-12.87.38-2.42c1.16-7.42,2.91-14.76,5.22-21.86l-34.89-12.69.81-2.33c3.43-9.88,7.76-19.53,12.87-28.7,5.13-9.19,11.09-17.97,17.72-26.09,6.08-7.48,12.86-14.56,20.16-21.07l-20.63-24.57Z',
    },
    {
        id: '1-4',
        sector: 4,
        d: 'M237.83,332.11l30.15,10.97c2.53-6.99,5.65-13.86,9.29-20.45,4.02-7.29,8.73-14.28,14-20.8,5.27-6.51,11.13-12.61,17.44-18.11,6.36-5.54,13.23-10.54,20.41-14.86,7.24-4.36,14.89-8.09,22.76-11.09,7.15-2.73,14.54-4.89,22-6.43l-5.58-31.61c-9.29,1.87-18.48,4.51-27.35,7.86-9.6,3.64-18.96,8.16-27.82,13.45l-2.18,1.3-18.54-32.1c-9.17,5.59-17.97,11.93-26.23,18.87l23.82,28.37-1.86,1.61c-7.79,6.76-14.99,14.19-21.41,22.08-6.45,7.9-12.24,16.44-17.23,25.37-4.57,8.19-8.5,16.78-11.69,25.58Z',
    },
    {
        id: '1-5',
        sector: 5,
        d: 'M186.48,267.31l27.79,16.03c5.92-10.26,12.7-20.07,20.17-29.19,8.02-9.79,16.97-18.96,26.59-27.25,9.65-8.32,20.08-15.81,30.99-22.29l2.18-1.29,18.56,32.12c8.46-4.89,17.34-9.1,26.43-12.55,9.16-3.46,18.65-6.19,28.25-8.11l-5.58-31.59c-11.43,2.24-22.72,5.45-33.6,9.54l-2.37.89-25.39-69.7c-14.84,5.69-29.31,12.66-43.04,20.76-13.71,8.1-26.81,17.38-38.96,27.61l23.82,28.38-1.88,1.61c-11.04,9.48-21.31,19.97-30.55,31.2-8.71,10.6-16.58,21.97-23.42,33.82Z',
    },
    {
        id: '1-6',
        sector: 6,
        d: 'M120,344.53l-.03.21c-2.57,15.46-3.89,31.33-3.9,47.19l69.16-.02c.01-11.81.97-23.63,2.85-35.13,2.02-12.43,5.16-24.77,9.33-36.68,3.89-11.12,8.73-22.01,14.41-32.4l-32.14-18.54,1.21-2.16c7.26-12.88,15.71-25.22,25.14-36.69h0c8.89-10.81,18.74-20.96,29.28-30.2l-20.62-24.56c-11.96,10.4-23.12,21.87-33.21,34.12-10.61,12.88-20.15,26.76-28.35,41.26-8.23,14.53-15.2,29.83-20.72,45.48-5.52,15.59-9.7,31.77-12.42,48.11Z',
    },
    {
        id: '1-7',
        sector: 7,
        d: 'M120.29,441.52l.45,2.45c2.83,15.51,6.97,30.84,12.3,45.6l64.99-23.68c-3.95-10.97-7.03-22.37-9.17-33.91-2.13-11.54-3.33-23.32-3.57-35.05l-74.18.02-.03-2.47c0-.78,0-1.56,0-2.34,0-16.13,1.32-32.28,3.93-48.01l.03-.2c2.77-16.7,7.03-33.24,12.67-49.17,5.34-15.15,12.02-29.98,19.87-44.11l-27.79-16.03c-8.74,15.68-16.21,32.2-22.21,49.14-6.27,17.66-11.02,36.02-14.12,54.58-2.95,17.64-4.45,35.74-4.45,53.81,0,.76,0,1.52.02,2.27.11,17.98,1.72,35.98,4.78,53.58l36.5-6.45Z',
    },
    {
        id: '1-8',
        sector: 8,
        d: 'M122.25,230.26l27.79,16.03c8.06-13.96,17.33-27.34,27.6-39.79,10.81-13.13,22.84-25.37,35.74-36.39,12.89-11.05,26.87-21.05,41.55-29.72,14.71-8.67,30.25-16.08,46.19-22.03,15.21-5.68,31-10.1,46.96-13.14l-12.03-68.11c-19.94,3.74-39.64,9.2-58.57,16.25-19.7,7.3-38.91,16.43-57.12,27.12-18.09,10.64-35.39,22.97-51.42,36.64-15.35,13.09-29.7,27.55-42.68,43.01l27.39,22.97v2.06l-.57.7c-11.47,13.89-21.83,28.82-30.82,44.4Z',
    },
    {
        id: '1-9',
        sector: 9,
        d: 'M55.53,197.53c-10.93,19.48-20.23,39.95-27.68,60.86-7.75,21.75-13.62,44.31-17.45,67.07-3.69,21.85-5.56,44.28-5.56,66.66,0,.77,0,1.55,0,2.32.13,23.15,2.26,46.32,6.34,68.88,3.94,21.86,9.75,43.49,17.3,64.33l30.15-10.99c-6.91-19.1-12.24-38.91-15.85-58.9l-.45-2.47,36.53-6.45c-3.11-17.87-4.74-36.15-4.85-54.37-.02-.74-.02-1.54-.02-2.35,0-18.34,1.52-36.72,4.51-54.63h0c3.15-18.85,7.97-37.49,14.34-55.43,6.1-17.22,13.7-34.02,22.59-49.96l-59.92-34.57Z',
    },
    {
        id: '1-10',
        sector: 10,
        d: 'M58,193.19l59.92,34.57c8.72-15.11,18.71-29.61,29.73-43.17l-28.42-23.83,1.58-1.91c13.58-16.41,28.67-31.73,44.87-45.54,16.25-13.86,33.79-26.36,52.13-37.14,18.46-10.84,37.94-20.1,57.91-27.5,19.22-7.15,39.2-12.69,59.45-16.49l-5.58-31.61c-22.08,4.13-43.87,10.16-64.83,17.93-21.75,8.06-42.93,18.11-62.95,29.87-19.97,11.72-39.06,25.29-56.74,40.34-17.62,15.01-34.05,31.66-48.83,49.5-14.25,17.2-27.11,35.68-38.25,54.98Z',
    },
    {
        id: '1-11',
        sector: 11,
        d: 'M118,85.23L0,256.18s54.29-88.73,3.01-124.12c0,0,54.53,40.75,114.98-46.83Z',
    },
];

/**
 * Illuminate faction paths (id prefix "2-"), sectors 1-11.
 */
export const illuminatePaths = [
    {
        id: '2-1',
        sector: 1,
        d: 'M327.41,459.97c3.28,3.67,6.85,7.11,10.62,10.26,4.4,3.68,9.17,7.02,14.15,9.92,4.96,2.88,10.23,5.36,15.64,7.37,5.37,2,10.98,3.54,16.67,4.6,5.69,1.06,11.49,1.63,17.25,1.7.52.02.98.02,1.43.02,4.5,0,8.99-.29,13.39-.87l-6.46-36.53,2.55-.37c3.64-.53,7.23-1.38,10.68-2.52,3.48-1.13,6.89-2.58,10.15-4.32,3.27-1.74,6.41-3.77,9.32-6.04,2.27-1.76,4.42-3.68,6.42-5.71l-24.73-20.75c-.84.73-1.71,1.41-2.61,2.03-1.48,1.05-3.08,1.99-4.73,2.78-1.64.78-3.34,1.42-5.07,1.9-1.76.5-3.53.85-5.27,1.03-1.56.2-3.43.28-5.28.17-1.71-.08-3.45-.31-5.16-.67-1.71-.36-3.39-.86-4.99-1.49-1.6-.62-3.17-1.38-4.66-2.26-1.47-.86-2.91-1.85-4.24-2.94-.7-.58-1.38-1.19-2.04-1.83l-53.05,44.54Z',
    },
    {
        id: '2-2',
        sector: 2,
        d: 'M292.32,528.66c7.18,5.84,14.84,11.13,22.81,15.74,8.74,5.06,17.94,9.38,27.35,12.84,9.47,3.49,19.28,6.15,29.16,7.93,9.83,1.79,19.97,2.74,30.13,2.82.49.01.97.01,1.42,0,8.83,0,17.67-.66,26.3-1.95l-6.45-36.52,2.5-.4c7.88-1.27,15.68-3.24,23.17-5.84,6.74-2.34,13.33-5.22,19.63-8.57l-18.56-32.13,2.25-1.23c5.14-2.81,10.05-6.08,14.62-9.74h0c3.91-3.12,7.62-6.57,11.05-10.27l-24.62-20.65c-2.24,2.29-4.65,4.45-7.2,6.43-3.14,2.44-6.52,4.63-10.04,6.5-3.52,1.88-7.2,3.45-10.94,4.66-2.9.96-5.91,1.73-8.97,2.29l6.46,36.55-2.51.4c-5.45.86-11.07,1.3-16.69,1.3-.52,0-1.05,0-1.56-.02-5.98-.07-12.07-.67-18.04-1.78-5.97-1.11-11.86-2.73-17.49-4.82-5.68-2.1-11.2-4.71-16.42-7.73-4.51-2.62-8.85-5.58-12.91-8.83l-44.45,53.01Z',
    },
    {
        id: '2-3',
        sector: 3,
        d: 'M404.24,572.99l.03,69.15c13.61-.06,27.26-1.22,40.6-3.46,13.41-2.25,26.7-5.61,39.53-10.02l-12.69-34.84,2.38-.84c11.58-4.09,22.87-9.22,33.57-15.26h0c9.97-5.62,19.55-12.1,28.53-19.28l-23.83-28.39,1.96-1.6c7.23-5.9,14.03-12.42,20.25-19.4l-53.04-44.48c-3.65,3.95-7.6,7.63-11.77,10.96-4.12,3.3-8.52,6.31-13.11,8.97l18.57,32.14-2.22,1.23c-7.22,4.02-14.85,7.43-22.66,10.14-6.97,2.42-14.2,4.32-21.51,5.63l6.45,36.54-2.49.41c-9.34,1.54-18.94,2.35-28.55,2.41Z',
    },
    {
        id: '2-4',
        sector: 4,
        d: 'M261.7,642c13.67,7.77,28.04,14.42,42.75,19.8,15.47,5.67,31.58,10.03,47.89,12.95,16.25,2.9,32.88,4.4,49.45,4.47.49.01.94,0,1.39.01,16.14,0,32.34-1.35,48.13-4.03l.22-.04c15.48-2.62,30.79-6.54,45.57-11.65l-10.99-30.16c-13.12,4.51-26.7,7.96-40.41,10.25-13.96,2.34-28.26,3.53-42.51,3.53-.49,0-.98,0-1.47-.01l-2.44-.06-.03-74.13c-9.62-.2-19.19-1.17-28.5-2.87-10.16-1.82-20.25-4.57-29.99-8.15-8.9-3.27-17.62-7.29-25.95-11.96l-53.09,92.03Z',
    },
    {
        id: '2-5',
        sector: 5,
        d: 'M197.02,642.31c13.13,10.84,27.18,20.68,41.81,29.31l71.63-124.16c-8.16-4.88-15.98-10.44-23.29-16.56-7.33-6.14-14.18-12.86-20.41-20l-52.97,44.47c8.85,10.25,18.57,19.84,28.95,28.52l1.92,1.61-47.64,56.81Z',
    },
    {
        id: '2-6',
        sector: 6,
        d: 'M100.2,650.75c14.43,16.88,30.32,32.61,47.24,46.79,17.62,14.78,36.62,28.09,56.49,39.58,19.18,11.11,39.4,20.65,60.14,28.38l36.32-99.87c-14.16-5.32-28-11.8-41.19-19.3l-18.54,32.14-2.17-1.25c-16.38-9.49-32.06-20.48-46.6-32.67-13.88-11.62-26.89-24.49-38.71-38.26l-52.97,44.48Z',
    },
    {
        id: '2-7',
        sector: 7,
        d: 'M454.64,679.7l5.58,31.6c17.63-3.12,35.1-7.75,51.95-13.77,17.62-6.29,34.83-14.19,51.14-23.48,16.29-9.27,31.89-20.04,46.36-32.01,13.82-11.43,26.79-24.1,38.56-37.68l-24.58-20.62c-10.56,12.14-22.2,23.49-34.63,33.76l-1.91,1.58-47.7-56.81c-9.21,7.38-19.05,14.04-29.29,19.81-10.22,5.76-20.97,10.72-31.99,14.76l25.39,69.71-2.37.85c-15.05,5.36-30.69,9.5-46.51,12.31Z',
    },
    {
        id: '2-8',
        sector: 8,
        d: 'M281.45,732.37c18.86,6.74,38.37,11.93,58.04,15.42,20.45,3.64,41.42,5.52,62.32,5.59.49,0,.93,0,1.37,0,20.5,0,41.04-1.73,61.04-5.14,20.6-3.5,41-8.84,60.64-15.87,18.87-6.74,37.3-15.13,54.82-24.96l-16.05-27.79c-15.92,8.91-32.66,16.51-49.77,22.62-17.91,6.39-36.49,11.24-55.24,14.41l-2.45.41-6.45-36.53c-15.3,2.45-30.94,3.69-46.53,3.69-.49,0-.98,0-1.46-.01-16.8-.07-33.73-1.6-50.26-4.55-15.77-2.82-31.36-6.97-46.37-12.32l-23.64,65.02Z',
    },
    {
        id: '2-9',
        sector: 9,
        d: 'M528.91,736.23l10.99,30.15c20.88-7.62,41.22-17.07,60.51-28.1,20.01-11.41,39.17-24.67,56.96-39.44,17.12-14.19,33.16-29.93,47.71-46.82l-53.01-44.44c-11.97,13.81-25.15,26.7-39.2,38.32-14.05,11.63-29.14,22.13-44.89,31.25l18.55,32.12-2.18,1.25c-17.69,10.09-36.33,18.74-55.43,25.71Z',
    },
    {
        id: '2-10',
        sector: 10,
        d: 'M268.77,767.22c20.85,7.47,42.46,13.22,64.29,17.1,22.57,4.01,45.71,6.07,68.77,6.14.48.01.9.02,1.35,0,22.68,0,45.39-1.92,67.49-5.7,21.87-3.72,43.56-9.33,64.52-16.7l-10.99-30.15c-19.19,6.72-39.07,11.85-59.14,15.26-20.27,3.46-41.09,5.21-61.88,5.21-.48,0-.96,0-1.43-.01-21.15-.07-42.4-1.97-63.14-5.67-19.95-3.54-39.75-8.8-58.88-15.64l-10.97,30.15Z',
    },
    {
        id: '2-11',
        sector: 11,
        d: 'M297.82,800.78h207.72s-103.86,5.72-103.86,68.03c0,0,2.56-68.03-103.86-68.03Z',
    },
];

/**
 * Super Earth circle definition.
 */
export const superEarthCircle = {
    id: '3-0',
    cx: 402.72,
    cy: 392.12,
    r: 27,
};

/**
 * Faction icon definitions (used by Map.jsx, not OG image).
 */
/**
 * Approximate center coordinates for each sector path (bounding-box midpoint).
 * Used for positioning permanent info cards on the map.
 */
export const sectorCentroids = {
    0: {
        // Bugs (right side)
        1: { x: 457, y: 353 },
        2: { x: 505, y: 366 },
        3: { x: 489, y: 275 },
        4: { x: 566, y: 361 },
        5: { x: 545, y: 269 },
        6: { x: 668, y: 365 },
        7: { x: 620, y: 202 },
        8: { x: 582, y: 140 },
        9: { x: 746, y: 372 },
        10: { x: 623, y: 133 },
        11: { x: 750, y: 176 },
    },
    1: {
        // Cyborgs (left side)
        1: { x: 366, y: 353 },
        2: { x: 323, y: 318 },
        3: { x: 264, y: 348 },
        4: { x: 306, y: 277 },
        5: { x: 277, y: 204 },
        6: { x: 176, y: 284 },
        7: { x: 139, y: 362 },
        8: { x: 235, y: 142 },
        9: { x: 60, y: 363 },
        10: { x: 197, y: 114 },
        11: { x: 59, y: 171 },
    },
    2: {
        // Illuminate (bottom)
        1: { x: 388, y: 455 },
        2: { x: 385, y: 504 },
        3: { x: 470, y: 553 },
        4: { x: 379, y: 615 },
        5: { x: 254, y: 591 },
        6: { x: 200, y: 686 },
        7: { x: 551, y: 637 },
        8: { x: 431, y: 710 },
        9: { x: 617, y: 687 },
        10: { x: 402, y: 764 },
        11: { x: 402, y: 835 },
    },
    3: {
        0: { x: 403, y: 392 },
    },
};

export const factionIcons = [
    {
        id: 'faction0',
        href: '/icons/faction0.webp',
        x: 710,
        y: 120,
        width: 100,
        height: 100,
    },
    {
        id: 'faction1',
        href: '/icons/faction1.webp',
        x: 0,
        y: 120,
        width: 100,
        height: 100,
    },
    {
        id: 'faction2',
        href: '/icons/faction2.webp',
        x: 354,
        y: 765,
        width: 100,
        height: 100,
    },
    {
        id: 'superearth',
        href: '/icons/superearth.webp',
        x: 352,
        y: 334,
        width: 100,
        height: 100,
    },
];
